<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ $t("transactions.cancelTransaction") }}</p>
      <button
        type="button"
        class="delete"
        @click="$parent.close()"
        :disabled="isSubmitting"
      />
    </header>

    <section class="modal-card-body">
      <p>{{ $t("transactions.cancelConfirmMessage") }}</p>

      <br />

      <b-field :label="$t('transactions.cancelReason')">
        <b-input
          type="textarea"
          v-model="reason"
          :placeholder="$t('transactions.cancelReasonPlaceholder')"
          :disabled="isSubmitting"
          maxlength="255"
        />
      </b-field>

      <b-field
        :label="$t('transactions.cancelPassword')"
        :message="$t('transactions.cancelPasswordHelp')"
      >
        <b-input
          type="password"
          password-reveal
          v-model="password"
          :disabled="isSubmitting"
        />
      </b-field>

      <p v-if="pollStatus === 'PENDING'" class="has-text-info">
        {{ $t("transactions.cancelling") }}
      </p>
    </section>

    <footer class="modal-card-foot">
      <button
        class="button"
        type="button"
        @click="$parent.close()"
        :disabled="isSubmitting"
      >
        {{ $t("common.cancel") }}
      </button>
      <button
        class="button is-danger"
        type="button"
        :disabled="!canSubmit"
        :class="{ 'is-loading': isSubmitting }"
        @click="submit"
      >
        {{ $t("transactions.cancelSubmit") }}
      </button>
    </footer>
  </div>
</template>

<script>
import { common } from "../../../mixins/common";

export default {
  props: ["transaction"],

  mixins: [common],

  data() {
    return {
      reason: "",
      password: "",
      isSubmitting: false,
      pollStatus: null,
      pollInterval: null
    };
  },

  computed: {
    canSubmit() {
      return (
        this.reason.trim().length > 0 &&
        this.password.length > 0 &&
        !this.isSubmitting
      );
    }
  },

  methods: {
    submit() {
      this.isSubmitting = true;

      this.$store
        .dispatch("cancelTransaction", {
          transactionId: this.transaction._id,
          reason: this.reason,
          password: this.password
        })
        .then(res => {
          if (res.data.result === "ok") {
            this.pollStatus = res.data.payload.pollStatus;

            if (res.data.payload.status === "success") {
              this.finish();
            } else if (res.data.payload.status === "error") {
              this.isSubmitting = false;
              this.alertCustomError(this.$t("transactions.statusError"));
            } else {
              this.startPolling();
            }
          } else {
            this.isSubmitting = false;
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.isSubmitting = false;
          this.alertError({ message: "UNEXPECTED_ERROR" });
        });
    },

    startPolling() {
      clearInterval(this.pollInterval);

      this.pollInterval = setInterval(() => {
        this.$store
          .dispatch("getTransactionCancelStatus", this.transaction._id)
          .then(res => {
            if (res.data.result !== "ok") return;

            this.pollStatus = res.data.payload.pollStatus;

            if (res.data.payload.status === "success") {
              this.finish();
            } else if (res.data.payload.status === "error") {
              clearInterval(this.pollInterval);
              this.isSubmitting = false;
              this.alertCustomError(this.$t("transactions.statusError"));
            }
          });
      }, 4000);
    },

    finish() {
      clearInterval(this.pollInterval);
      this.isSubmitting = false;

      this.$buefy.toast.open({
        message: this.$t("transactions.cancelSuccess"),
        type: "is-success"
      });

      this.$emit("cancelled");
      this.$parent.close();
    }
  },

  destroyed() {
    clearInterval(this.pollInterval);
  }
};
</script>
